
/**
 * 
 */

import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Trans } from "react-i18next";
import TopicMatrix from "./../TopicMatrix/TopicMatrix";


function MatrixSlide( props ) {

  const navigate = useNavigate();
  let { id } = useParams();

  const smoothScrollTo = function(e, target) {
    e.preventDefault();
    
    // position offset
    let scrollLeftTo = window.jQuery( target ).position().left - 24; // - 38;

    window.jQuery('#matrix-slide').animate({
        scrollLeft: scrollLeftTo
    }, 300);

    /*
    const href = target;
    const offsetLeft = document.querySelector(href).offsetLeft;
    
    window.scroll({
      left: offsetLeft,
      behavior: "smooth"
    });
    */
  }
  

  let problemsCardsOrdered = [];
  for ( var i in props.items ){
    problemsCardsOrdered.push( props.items[ i ] );
  }

  const orderProblemsFirst = function( a, b ) {
    
    if ( a.priorityColorNr < b.priorityColorNr ){
      return 1;
    }

    if ( a.priorityColorNr > b.priorityColorNr ){
      return -1;
    }

    return 0;
  }


  const handlePdfDownloadClick = () => {
    if( typeof props.onPdfDownloadClick !== "undefined" ){
      props.onPdfDownloadClick();
    }
  }

  let pdfHasGenerated = false;
  if( typeof props.pdfHasGenerated !== "undefined" ){
    pdfHasGenerated = props.pdfHasGenerated;
  }
  
  problemsCardsOrdered.sort( orderProblemsFirst );
  
  return (
  <div>
    <h2>
      <Trans>Summary</Trans> 
      {( pdfHasGenerated ) && (
        <div className="download-pdf borderless pl-2" onClick={handlePdfDownloadClick}><Trans>Download as .pdf</Trans></div>
      )}
    </h2>

    <div className="app-fragment matrix-slide grid grid-flow-col gap-x-4" id="matrix-slide">
      
      <div className="slide-item matrix">
        <div className="grid grid-flow-row grid-cols-4">

          {props.items.map( function( obj, index){
            let key = index + new Date().getTime();
            let targetKey = '#target-' + obj.problemCode;
            let classes = 'matrix-item indicator ' + obj.priorityColor;
            
            return (
              <a href={targetKey} onClick={( e ) => { smoothScrollTo( e, targetKey); } } key={key} className={classes}>{obj.letter}</a>
            );
          })}

        </div>
      </div>
      
      {problemsCardsOrdered.map( function( obj, index){
        let key = index + '-big-' + new Date().getTime();
        let targetKey = 'target-' + obj.problemCode;
        let classes = 'title-indicator indicator ' + obj.priorityColor;
        
        return (
          <div key={key} id={targetKey} className="slide-item topic-card">
            <h3><div className={classes}></div>{obj.topic} ({obj.letter})</h3>
            <div className="slide-content-wrap">
              <div className="slide-content">
                <Trans>{obj.content}</Trans>
              </div>
            </div>
          </div>
        );
      })}
      
      <div className="slide-item topic-card">
        <h3><Trans>Download the self-assessment summary</Trans></h3>
        <div className="slide-content-wrap">
          <div className="slide-content">
            {( pdfHasGenerated ) && (
              <div className="download-pdf pl-4 pr-4" onClick={handlePdfDownloadClick}>
                <Trans>Download to .pdf</Trans>
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  </div>
  );
}


export default MatrixSlide;
